var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarWithoutDate = function SvgCalendarWithoutDate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 3.6665C0.666626 2.74603 1.41282 1.99984 2.33329 1.99984H13.6666C14.5871 1.99984 15.3333 2.74603 15.3333 3.6665V13.6665C15.3333 14.587 14.5871 15.3332 13.6666 15.3332H2.33329C1.41282 15.3332 0.666626 14.587 0.666626 13.6665V3.6665ZM2.33329 3.33317C2.1492 3.33317 1.99996 3.48241 1.99996 3.6665V13.6665C1.99996 13.8506 2.1492 13.9998 2.33329 13.9998H13.6666C13.8507 13.9998 14 13.8506 14 13.6665V3.6665C14 3.48241 13.8507 3.33317 13.6666 3.33317H2.33329Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99996 0.666504C5.36815 0.666504 5.66663 0.964981 5.66663 1.33317V3.99984C5.66663 4.36803 5.36815 4.6665 4.99996 4.6665C4.63177 4.6665 4.33329 4.36803 4.33329 3.99984V1.33317C4.33329 0.964981 4.63177 0.666504 4.99996 0.666504Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.666504C11.3681 0.666504 11.6666 0.964981 11.6666 1.33317V3.99984C11.6666 4.36803 11.3681 4.6665 11 4.6665C10.6318 4.6665 10.3333 4.36803 10.3333 3.99984V1.33317C10.3333 0.964981 10.6318 0.666504 11 0.666504Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarWithoutDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-without-date.45613628.svg";
export { ForwardRef as ReactComponent };